/**
 * Provider de tema ACV para GanGen.
 * El bridge crítico de postMessage vive en src/index.tsx para registrarse
 * antes de montar React y no perder mensajes tempranos del host.
 */
import { useExtensionTheme } from '../hooks/useExtensionTheme';

export function ExtensionThemeProvider({ children }: { children: React.ReactNode }) {
  useExtensionTheme();

  return <>{children}</>;
}
